import realtimeFilter from './realtime/index';

export default {
  ...realtimeFilter
}
